import { ProjectSkillsPage } from "@/features/projects/project-skills.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/",
)({
  component: ProjectSkillsPage,
});
